import React from 'react';

import { useVehiclePhotosByKind } from 'Components/Gallery';
import type { GalleryImageWithTitle } from 'Components/Gallery/MainGallery/MainGallery';
import type { NumericGradeValues } from 'Pages/vehicles/helpers/vehicle.schema';
import { NUMERIC_GRADE_VALUES } from 'Pages/vehicles/helpers/vehicle.schema';

import { DamageCard } from '../DamageCard';

import styles from './MobilizeExteriorDamage.module.scss';

interface MobilizeExteriorDamageProps {
	numericGrade: NumericGradeValues | null;
}

export const getDistinctPanelCount = (images: GalleryImageWithTitle[]): number => {
	const panelTypes = new Set<string>();
	for (const image of images) {
		if ('damageMeta' in image && image.damageMeta) {
			const { panelType } = image.damageMeta;
			if (typeof panelType === 'string' && panelType.length > 0) {
				panelTypes.add(panelType);
			}
		}
	}
	return panelTypes.size;
};

export const MobilizeExteriorDamage: React.FC<MobilizeExteriorDamageProps> = ({ numericGrade }) => {
	const images = useVehiclePhotosByKind(['damage_exterior']);

	if (images.length === 0) {
		return null;
	}

	const panelCount = getDistinctPanelCount(images);

	return (
		<div className={styles.section} data-testid="mobilize-exterior-damage">
			<div className={styles.field}>
				<div className={styles.label}>Exterior grade</div>
				<div className={styles.value}>
					{numericGrade && NUMERIC_GRADE_VALUES.includes(numericGrade) ? <span>Grade {numericGrade}</span> : '-'}
				</div>
			</div>
			<div className={styles.field}>
				<div className={styles.label}>Panels damaged</div>
				<div className={styles.value} data-testid="panels-damaged-count">
					{panelCount}
				</div>
			</div>
			<div className={styles.grid}>
				{images.map((image) => (
					<DamageCard key={image.id} showOverlay image={image} />
				))}
			</div>
		</div>
	);
};
